export const check_types = ['freshness', 'schema', 'volume', 'distribution'];
export const FRESHNESS = 'freshness';
export const SCHEMA = 'schema';
export const VOLUME = 'volume';
export const DISTRIBUTION = 'distribution';
